<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <el-breadcrumb class="breadcrumb" separator="/">
          <el-breadcrumb-item :to="{ name: 'home' }">Inicio</el-breadcrumb-item>
          <el-breadcrumb-item>Preguntas Frecuentes</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <el-card>
          <template slot="header">
            <h5 class="pp-card-title" data-cy="card-title">Listado de preguntas Frecuentes</h5>
          </template>

          <div v-loading="loading">
            <template v-if="errored">
              <div class="row mx-3">
                <div class="col-12">
                  <span class="text-h2 text-warning"
                        data-cy="error-faq">No se pudo obtener las Preguntas Frecuentes.</span>
                </div>
              </div>
            </template>

            <template v-else>
              <div class="faqs row mx-3 my-3" :class="media">

                <div class="col-sm-12">
                  <el-collapse>
                    <template v-for="(faq, index) in listaFaq">
                      <el-collapse-item :title="faq.titulo" :name="index" class="collapse-item">
                        <div class="faq-texto" v-html="faq.texto"></div>
                      </el-collapse-item>
                    </template>

                  </el-collapse>
                </div>
              </div>
            </template>

          </div>

        </el-card>
      </div>
    </div>
  </div>

</template>

<script>
import {Breadcrumb, BreadcrumbItem, Collapse, CollapseItem} from 'element-ui'
import {NotifyMixin} from "@/mixins/NotifyMixin";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {requestAfiliacionMixin} from "@/api/ciudadano/afiliacionApi";

export default {
  name: "Faq",
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
  },
  mixins: [
    NotifyMixin,
    ScreenSizeMixin,
    requestAfiliacionMixin
  ],
  data: () => ({
    loading: false,
    errored: false,
    listaFaq: [],
  }),
  beforeMount() {
    this.loading = true
    this.errored = false
    this.getFaqs()
      .then((response) => {
        this.$log.debug('getFaqs', response.data.statusCode, response.data)

        if (response.data.statusCode === 200) {
          this.listaFaq = JSON.parse(response.data.datos)

          if(this.listaFaq.length === 0) {
            this.errored = true
            this.showError('Ocurrió un error inesperado al cargar las faq')
          }
        } else {
          this.errored = true
          this.showError('Ocurrió un error inesperado al cargar las faq')
        }
        this.loading = false
      })
      .catch(err => {
        this.$log.fatal('getFaqs', err.response, err.request)
        this.showError('Ocurrió un error inesperado al cargar las faq')
        this.errored = true
      })
  }
}
</script>

<style lang="scss">
.faq-texto {
  font-size: 14px;
}

.collapse-item .el-collapse-item__header {
  height: auto !important;
}

.faqs {
  &.sm {
    margin-left: 0 !important;
    margin-right: 0 !important;

    .col-sm-12 {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}
</style>
